import { getSupabase } from '../services/supabase';

export const CLASS_SESSION_PAGE_SIZE = 50;

export type SchedulePrimaryPageRequest = {
  from: string;
  until: string;
  zone: string | null;
  groupId: number | null;
  status: 'SCHEDULED' | 'OPEN' | 'IN_PROGRESS' | 'COMPLETED' | 'CANCELLED' | null;
  sourceType: 'MANUAL' | 'SCHEDULE_OCCURRENCE' | null;
  after: { startsAt: string; classSessionId: number } | null;
  classSessionId: number | null;
};

export const defaultSchedulePrimaryPageRequest = (): SchedulePrimaryPageRequest => {
  const now = new Date();
  const year = now.getUTCFullYear();
  const month = now.getUTCMonth();
  const from = new Date(Date.UTC(year, month, 1)).toISOString().slice(0, 10);
  const until = new Date(Date.UTC(year, month + 1, 0)).toISOString().slice(0, 10);
  return {
    from,
    until,
    zone: null,
    groupId: null,
    status: null,
    sourceType: null,
    after: null,
    classSessionId: null,
  };
};

export const requestScheduleWorkspace = async (
  signal: AbortSignal,
  request: SchedulePrimaryPageRequest,
) => {
  const result = await getSupabase()
    .rpc('read_schedule_workspace_v1', {
      p_from: request.from,
      p_until: request.until,
      p_page_size: CLASS_SESSION_PAGE_SIZE + 1,
      ...(request.zone ? { p_timezone_name: request.zone } : {}),
      ...(request.after
        ? {
            p_after_starts_at: request.after.startsAt,
            p_after_class_session_id: request.after.classSessionId,
          }
        : {}),
      ...(request.groupId === null ? {} : { p_group_id: request.groupId }),
      ...(request.status === null ? {} : { p_status: request.status }),
      ...(request.sourceType === null ? {} : { p_source_type: request.sourceType }),
      ...(request.classSessionId === null ? {} : { p_class_session_id: request.classSessionId }),
    })
    .abortSignal(signal);
  if (result.error) throw result.error;
  return result.data;
};
